import Lightense from "lightense-images";
export default function lightense() {
    window.addEventListener("load", function () {
        const image = document.querySelector(".gh-content .kg-gallery-card img");
        if (image) {
            Lightense(".gh-content .kg-gallery-card img", {
                padding: 60,
                offset: 0
            });
        }
    }, false);
}